// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLabel_label__BjxdR","required":"FormLabel_required__3hCBQ"};